import styled from "styled-components";

export const StyledDropDown = styled.div`
  width: 100%;
  position: relative;
  z-index: 25;
`;

export const StyledDropDownBtn = styled.div`
  color: white !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px;
  .dropdown {
    display: none;
  }
  :hover .dropdown {
    display: block;
  }
`;

export const StyledDropDownContant = styled.div`
  position: absolute;
  top: 43px;
  right: 2px;
  background-color: white;
  font-weight: 500;
  overflow: auto;
  overflow-x: hidden;
  border-radius: 2%;
  box-shadow: 0px 1px 4px 0px #00000036;
  padding: 0;
  min-width: max-content;
  & a {
    color: #2b2b2b !important;
    display: flex;
    justify-content: start;
    align-items: center;
    text-align: right;
    border-bottom: 1px solid #d7d7d7;
    font-size: 13px;
    padding: 8px;
    padding-right: 12px;
    padding-left: 15px;
    transition: 0.3s;
    :hover {
      background: #0000000a;
      color: #0084a7 !important;
    }
  }
`;

export const StyledDropDownItem = styled.span`
  padding: 10px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: right;
  border-radius: 4%;

  // &:hover {
  //   background-color: white !important;
  //   color: #04c1f3 !important;
  // }
`;
